/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Asset Type that is used for filtering.
 *
 */
export var AssetSourceIdPropertyForFiltering;
(function (AssetSourceIdPropertyForFiltering) {
    AssetSourceIdPropertyForFiltering["ASSET_SOURCE_ID"] = "assetSourceId";
})(AssetSourceIdPropertyForFiltering || (AssetSourceIdPropertyForFiltering = {}));
